import { useFeatureToggles } from '../../../../feature-toggles';
import { useRoleThemes } from '../../../../authentication/use-role-themes';
import { useAllowedActions } from '../../../../authentication/use-allowed-actions';
import {
  ResourceOperations,
  ResourceTypes,
} from '../../../../authentication/resources';

export const aiServiceProviderDemoToggle = 'ShowAiServiceProviderDemo';

export function useAiServiceProviderDemoAccess() {
  const { isFeatureEnabled } = useFeatureToggles();
  const { isServiceProvider } = useRoleThemes();
  const canReadDiary = useAllowedActions().isAnyAllowed([
    {
      resourceType: ResourceTypes.ServiceProviderCitizenDiary,
      resourceOperation: ResourceOperations.Read,
    },
  ]);

  return (
    isFeatureEnabled(aiServiceProviderDemoToggle) &&
    isServiceProvider &&
    canReadDiary
  );
}
